import * as React from "react";
const SvgFiRrPeapod = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-peapod_svg__a)">
      <path
        fill="#062147"
        d="M22.854 1.161A3.98 3.98 0 0 0 19.317.07C15.616.76 10.326 2.834 6.58 6.58 2.834 10.325.76 15.614.069 19.317a3.99 3.99 0 0 0 1.094 3.538 3.98 3.98 0 0 0 3.512 1.116c1.77-.317 7.918-1.724 12.745-6.55 4.827-4.827 6.233-10.978 6.55-12.748a3.97 3.97 0 0 0-1.117-3.513zm-.852 3.162c-.6 3.348-2.487 8.176-5.995 11.685-3.508 3.508-8.335 5.397-11.683 5.995a1.94 1.94 0 0 1-1.741-.558 1.96 1.96 0 0 1-.547-1.762c.636-3.407 2.535-8.268 5.957-11.69 3.422-3.42 8.283-5.322 11.69-5.958q.186-.035.37-.035c.518 0 1.01.203 1.392.581.468.465.67 1.1.557 1.742M12 14.001A2 2 0 1 1 8 14a2 2 0 0 1 3.999 0m4-4A2 2 0 1 1 12 10a2 2 0 0 1 3.999 0m-8 8A2 2 0 1 1 4 18a2 2 0 0 1 3.999 0M20 6A2 2 0 1 1 16 6a2 2 0 0 1 3.999 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-peapod_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPeapod;
